import React from 'react';

export const GenericForm = ({ component, onUpdate }) => {
  const { specificAttrs = {} } = component;

  const handleChange = (key, value) => {
    onUpdate(component.id, {
      specificAttrs: {
        ...specificAttrs,
        [key]: value
      }
    });
  };

  const renderField = (key, value) => {
    const isBoolean = typeof value === 'boolean';
    const isNumber = typeof value === 'number';
    const isLongText = typeof value === 'string' && value.length > 50;

    return (
      <div key={key} style={{ marginBottom: '12px' }}>
        <label style={{
          display: 'block',
          fontSize: '12px',
          fontWeight: '500',
          marginBottom: '4px',
          color: '#374151',
          textTransform: 'capitalize'
        }}>
          {key.replace(/([A-Z])/g, ' $1').trim()}
        </label>
        
        {isBoolean ? (
          <input
            type="checkbox"
            checked={value}
            onChange={(e) => handleChange(key, e.target.checked)}
            style={{
              width: '16px',
              height: '16px',
              cursor: 'pointer'
            }}
          />
        ) : isNumber ? (
          <input
            type="number"
            value={value}
            onChange={(e) => handleChange(key, parseFloat(e.target.value) || 0)}
            style={{
              width: '100%',
              padding: '6px 8px',
              fontSize: '13px',
              border: '1px solid #D1D5DB',
              borderRadius: '4px'
            }}
          />
        ) : isLongText ? (
          <textarea
            value={value}
            onChange={(e) => handleChange(key, e.target.value)}
            rows={3}
            style={{
              width: '100%',
              padding: '6px 8px',
              fontSize: '13px',
              border: '1px solid #D1D5DB',
              borderRadius: '4px',
              fontFamily: 'inherit',
              resize: 'vertical'
            }}
          />
        ) : (
          <input
            type="text"
            value={value}
            onChange={(e) => handleChange(key, e.target.value)}
            style={{
              width: '100%',
              padding: '6px 8px',
              fontSize: '13px',
              border: '1px solid #D1D5DB',
              borderRadius: '4px'
            }}
          />
        )}
      </div>
    );
  };

  return (
    <div style={{
      padding: '12px',
      background: '#F9FAFB',
      borderRadius: '6px'
    }}>
      <h4 style={{
        margin: '0 0 12px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#111827'
      }}>
        {component.type} Properties
      </h4>
      
      {Object.entries(specificAttrs).map(([key, value]) => renderField(key, value))}
      
      {Object.keys(specificAttrs).length === 0 && (
        <div style={{
          padding: '12px',
          fontSize: '12px',
          color: '#9CA3AF',
          textAlign: 'center'
        }}>
          No specific attributes defined
        </div>
      )}
    </div>
  );
};
